const routerData={
  namespaced: true,
  state: {
      routerList: []
  },
  mutations: {
    changeRouterList(state, data) {
      state.routerList = data
    }
  }
}

export default routerData
